import { render } from "./TermTabsItems.vue?vue&type=template&id=46197f70&scoped=true"
import script from "./TermTabsItems.vue?vue&type=script&lang=js"
export * from "./TermTabsItems.vue?vue&type=script&lang=js"

import "./TermTabsItems.vue?vue&type=style&index=0&id=46197f70&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\wordpress\\wp-content\\themes\\yka-theme-2022\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46197f70"]])

export default __exports__